import { useMutation } from '@tanstack/react-query';

import {
  type Calendar_UpsertEventTag,
  gqlClient,
  graphql,
  queryClient,
} from '@tyro/api';
import { toast } from '@tyro/core';
import { useTranslation } from '@tyro/i18n';
import { calendarKeys } from '../keys';

const upsertCalendarEventTag = graphql(/* GraphQL */ `
  mutation calendar_upsertEventTag($input: Calendar_UpsertEventTag!) {
    calendar_upsertEventTag(input: $input) {
      success
    }
  }
`);

export function useUpsertCalendarEventTag() {
  const { t } = useTranslation(['common']);

  return useMutation({
    mutationFn: async (input: Calendar_UpsertEventTag) =>
      gqlClient.request(upsertCalendarEventTag, { input }),
    onSuccess: async (_, { id }) => {
      await queryClient.invalidateQueries({ queryKey: calendarKeys.all });
      toast.success(
        id
          ? t('common:snackbarMessages.updateSuccess')
          : t('common:snackbarMessages.createSuccess'),
      );
    },
    onError: () => {
      toast.error(t('common:snackbarMessages.errorFailed'));
    },
  });
}
